import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { TransporterService } from '../../../services/transporter/transporter.service';
import { MatSnackBar, MAT_DIALOG_DATA,MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { StoreUserDetails } from '../../../auth/storeuserdetails';


@Component({
  selector: 'app-edittransporter',
  templateUrl: './edittransporter.component.html',
  styleUrls: ['./edittransporter.component.scss']
})
export class EdittransporterComponent implements OnInit {


  transporterForm: FormGroup;
  transporterName: string;
  transporterAddress1: string;
  transporterAddress2: string;
  transporterAddress3: string;
  transporterPhoneNumber: string;
  contactPersonName: string;
  contactPersonPhoneNumber: string;
  secondarycontactPersonPhoneNumber: string;

  constructor(
    private formBuilder: FormBuilder,
    private transporterService: TransporterService,
    public snackBar: MatSnackBar,
    private router: Router,
    private matDialog: MatDialog,
    private userDetails: StoreUserDetails,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) {
    this.transporterForm = formBuilder.group({
      'transporterName': [null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z_ ]+$")
      ]],
      'transporterAddress1': [null, Validators.required],
      'transporterAddress2': [null],
      'transporterAddress3': [null],
      'transporterPhoneNumber': [null, Validators.compose([
        Validators.required, Validators.minLength(10), Validators.maxLength(10)
      ])],
      'contactPersonName': [null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z_ ]+$")
      ]],
      'contactPersonPhoneNumber': [null, Validators.compose([
        Validators.required, Validators.minLength(10), Validators.maxLength(10)
      ])],
      // 'secondarycontactPersonPhoneNumber': [null, Validators.compose([Validators.minLength(10), Validators.maxLength(10)
      // ])],
      'city':[null],
      'pincode': [null],
      'state': [null],
      'country': [null],
      'bIsActive': [null],
      'branchName': [null],
      'contactPersonEmailId':[null],
      'creationDateTime':[null],
      'transporterId':[null],
      'updatedByusername': [null],
      'updatedDateTime': [null]
    });
  }

  openSnackBar(message) {
    let extraClasses;

    this.snackBar.open(message, 'ok', {
      duration: 10000,
      panelClass: ['extraClasses']
    });
  }

  editTransporter() {
    if (this.transporterForm.valid) {
      console.log(this.transporterForm.value);
      this.transporterService.updateTransporter(this.transporterForm.value).subscribe(res => {
        console.log(res);
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
        this.router.navigate(["/transporter"])); 
        this.matDialog.closeAll();
        this.openSnackBar("Transporter: " + this.transporterForm.value.transporterName + " updated successfully");        
      }, Error => {
        console.log(Error);
      })

    }


  }


  ngOnInit() {
    console.log(this.data);
    
    this.transporterService.getTransporterById(this.data).subscribe(res =>{
      console.log(res);
      this.transporterForm.patchValue({
        transporterName: res.transporterName,
        transporterAddress1: res.transporterAddress1,
        transporterAddress2: res.transporterAddress2,
        transporterAddress3: res.transporterAddress3,
        transporterPhoneNumber: res.transporterPhoneNumber,
        pincode: res.pincode,
        city: res.city,
        state: res.state,
        country: res.country,
        bIsActive: res.bIsActive,
        contactPersonName: res.contactPersonName,
        contactPersonPhoneNumber: res.contactPersonPhoneNumber,
        branchName: res.branchName,
        contactPersonEmailId: res.contactPersonEmailId,
        creationDateTime: res.creationDateTime,
        transporterId: res.transporterId,
        updatedByusername: this.userDetails.getUser(),
      })
    }, Error => {
      console.log(Error)
    })

  }

}
